"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMonthSelectorColumn = exports.StyledMonthSelectorArrowContainer = exports.StyledMonthSelectorSeparator = exports.StyledMonthSelectorSection = exports.StyledMonthSelectorBody = exports.StyledMonthSelector = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const SelectableItem_styles_1 = require("../helpers/components/SelectableItem/SelectableItem.styles");
exports.StyledMonthSelector = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;
exports.StyledMonthSelectorBody = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    align-items: stretch;
`;
exports.StyledMonthSelectorSection = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
`;
exports.StyledMonthSelectorSeparator = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    width: 1px;
    margin: 0 24px;
    flex-shrink: 0;
    background: ${({ theme }) => theme.colorBorderMain};
`;
exports.StyledMonthSelectorArrowContainer = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 32px;
`;
exports.StyledMonthSelectorColumn = styled_components_1.default.div `
    display: flex;
    flex-direction: column;

    ${SelectableItem_styles_1.StyledSelectableItem} {
        width: 48px;
        justify-content: center;
    }
`;
//# sourceMappingURL=MonthSelector.styles.js.map